"use client";

import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { LayoutDashboard, Package, ReceiptText, ScrollText, RotateCcw, Wallet, Settings2, LogOut, LayoutTemplate, Users } from "lucide-react";
import { clearToken } from "@/lib/auth";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

const menus = [
  { href: "/dashboard", label: "仪表盘", icon: LayoutDashboard },
  { href: "/users", label: "用户管理", icon: Users },
  { href: "/products", label: "商品管理", icon: Package },
  { href: "/gallery", label: "模版广场", icon: LayoutTemplate },
  { href: "/orders", label: "订单管理", icon: ReceiptText },
  { href: "/bills", label: "账单流水", icon: ScrollText },
  { href: "/refunds", label: "退款审核", icon: RotateCcw },
  { href: "/payment-channels", label: "支付渠道", icon: Wallet },
  { href: "/system-configs", label: "系统配置", icon: Settings2 },
];

export function AdminSidebar() {
  const pathname = usePathname();
  const router = useRouter();

  return (
    <aside className="w-64 shrink-0 border-r bg-card/80 backdrop-blur">
      <div className="px-5 py-6 border-b">
        <div className="text-xs uppercase tracking-wider text-muted-foreground">AutoGen</div>
        <div className="mt-1 text-lg font-semibold">啊头真管理后台</div>
      </div>
      <nav className="p-3 space-y-1">
        {menus.map((item) => {
          const Icon = item.icon;
          const active = pathname === item.href;
          return (
            <Link
              key={item.href}
              href={item.href}
              className={cn(
                "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
                active ? "bg-primary text-primary-foreground" : "hover:bg-muted"
              )}
            >
              <Icon className="h-4 w-4" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
      <div className="p-3 border-t mt-auto">
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => {
            clearToken();
            router.replace("/login");
          }}
        >
          <LogOut className="h-4 w-4" />
          退出登录
        </Button>
      </div>
    </aside>
  );
}
